var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 24.5,
    stroke: "#DBFF00",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3582 24.5256C15.9039 24.5269 15.4592 24.6568 15.0757 24.9002C14.6921 25.1436 14.3853 25.4907 14.1908 25.9012C13.9962 26.3118 13.9219 26.769 13.9763 27.22C14.0308 27.671 14.2119 28.0974 14.4985 28.4498L20.6099 35.9363C20.8278 36.2068 21.1071 36.4215 21.4247 36.5624C21.7422 36.7034 22.0888 36.7665 22.4356 36.7466C23.1774 36.7068 23.8471 36.31 24.2741 35.6575L36.969 15.2124C36.9711 15.209 36.9733 15.2056 36.9755 15.2023C37.0946 15.0194 37.056 14.6569 36.8101 14.4292C36.7426 14.3667 36.6629 14.3187 36.5761 14.2881C36.4893 14.2575 36.3972 14.245 36.3054 14.2514C36.2135 14.2577 36.124 14.2828 36.0422 14.3251C35.9605 14.3674 35.8883 14.426 35.83 14.4972C35.8254 14.5028 35.8208 14.5083 35.8159 14.5138L23.0129 28.9793C22.9642 29.0343 22.905 29.0791 22.8389 29.1111C22.7727 29.1431 22.7008 29.1616 22.6274 29.1656C22.554 29.1695 22.4805 29.1589 22.4113 29.1342C22.342 29.1096 22.2784 29.0714 22.224 29.0219L17.9749 25.1552C17.5336 24.7507 16.9568 24.5261 16.3582 24.5256Z",
    fill: "#DBFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.20800aa4395e75a44960689ec8a4307b.svg";
export { ForwardRef as ReactComponent };